import axios from "../plugins/parseAxios";
export class DailyBillingSettingAPI {
  constructor(props) { }
  static createDailyBillingSetting(payload) {
    return axios.post("functions/createDailyBillingSetting", payload);
  }
  static getDailyBillingSettings(payload) {
    return axios.post("functions/getDailyBillingSettings", payload);
  }
  static updateDailyBillingSetting(payload) {
    return axios.post("functions/updateDailyBillingSetting", payload);
  }
  static removeDailyBillingSetting(payload) {
    return axios.post("functions/removeDailyBillingSetting", payload);
  }
  static getDailyBillingSettingsByAreas(payload) {
    return axios.post("functions/getDailyBillingSettingsByAreas", payload)
  }
  static getDailyBillingSettingsByIncludeArea(payload) {
    return axios.post("functions/getDailyBillingSettingsByIncludeArea", { areaIds: payload.areaIds })
  }
  static getDailyBillingSettingsByMeters(payload) {
    return axios.post("functions/getDailyBillingSettingsByMeters", { meterIds: payload.meterIds })
  }
  static getDailyBillingSettingsByIds(ids) {
    return axios.post("functions/getDailyBillingSettingsByIds", {
      ids
    });
  }
}
